import React, { Component, PropTypes } from 'react'

class LogSubmission extends Component {
  constructor(props){
    super(props);
    this.state = { val : "" }
  }
  componentDidMount(){
    this.setTimeLeft()
    this.interval = setInterval(this.setTimeLeft.bind(this), 1000)
  }
  componentWillUnmount(){
    clearInterval(this.interval)
  }
  setTimeLeft(){
    if (this.props.nextChallenge && this.props.nextChallenge.time) {
      let secondsLeft = Math.floor((this.props.nextChallenge.time - new Date()) / 1000)
      this.setState({
        secondsLeft
      })
    }
  }
  handleChange(e){
    this.setState({
      val: e.target.value
    })
  }
  handleSubmit(e){
    e.preventDefault();
    this.props.submitChallenge(this.state.val)
    this.setState({
      val: ""
    })
  }
  renderCountdown() {
    let secondsLeft = this.state.secondsLeft
    let countdown
    if (typeof secondsLeft !== 'number') {
      countdown = <span></span>
    }
    else if (secondsLeft > 0) {
      let hours = Math.floor(secondsLeft / 3600)
      let minutes = Math.floor(secondsLeft / 60) % 60
      if (minutes < 10) minutes = '0' + minutes
      let seconds = secondsLeft % 60
      if (seconds < 10) seconds = '0' + seconds
      countdown = <h3 className="countdown">New challenge in { hours }:{ minutes }:{ seconds }</h3>
    }
    else {
      countdown = <h3 className="countdown">New challenge is up! <a href="/challenge">Refresh</a></h3>
    }
    return countdown
  }
  render() {
    const { data } = this.props,
          isHidden = (data.remainingPuzzle === 0 && data.totalMoves) ? 'show' : 'hide'
    if (!data.isChallenge) return <div />

    return (
      <div className = 'submission'>
        <p>Puzzles Remaining: { data.remainingPuzzle }</p>
        <p>Total Number of Moves: { data.totalMoves }</p>
        <div className = { "solved " + isHidden } >
          <h3>YOU SOLVED ALL THE PUZZLES!!</h3>
          <form onSubmit = { this.handleSubmit.bind(this) }>
            <input type="text" placeholder="Your Name" className="text-input" onChange={ this.handleChange.bind(this) } value = { this.state.val }/>
            <input type="submit" className="submit-button"/>
          </form>
          <p>Submit your solution to see how you <a href='/highscore'>rank against other players</a> or hone your skills in the <a href='/classic'>practice mode</a>.</p>
          { this.renderCountdown() }
        </div>
      </div>
    )
  }
}

LogSubmission.propTypes = {
  
}

export default LogSubmission



// WEBPACK FOOTER //
// ./components/LogSubmission.js